import {
  auditByConstants,
  auditBy_nameSpace,
} from "../constants/activityLog.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null,
};

export const auditBy = (state = initialState, action) => {
  switch (action.type) {
    case auditByConstants[`GET_${auditBy_nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request,
      };
    case auditByConstants[`GET_${auditBy_nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null,
      };
    case auditByConstants[`GET_${auditBy_nameSpace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
      };
    default:
      return state;
  }
};
